import { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { ChatCircleDots, Envelope, DeviceMobile } from '@phosphor-icons/react';
import { Card, CardContent } from '../components/ui/card';
import { AcumbamailPanel } from '../components/settings/AcumbamailPanel';
import { EsendexPanel } from '../components/settings/EsendexPanel';

export default function Communications() {
  const { lang } = useLanguage();
  const [activePanel, setActivePanel] = useState(null);

  const lb = lang === 'es' ? {
    title: 'Comunicaciones',
    emailTitle: 'Gestionar Emails',
    emailDesc: 'Listas de suscriptores, plantillas y campanas de email via Acumbamail',
    smsTitle: 'Gestionar SMS',
    smsDesc: 'Envio de SMS, plantillas, historial y recordatorios automaticos de citas via Esendex',
    back: 'Volver',
  } : {
    title: 'Communications',
    emailTitle: 'Manage Emails',
    emailDesc: 'Subscriber lists, templates and email campaigns via Acumbamail',
    smsTitle: 'Manage SMS',
    smsDesc: 'Send SMS, templates, history and automatic appointment reminders via Esendex',
    back: 'Back',
  };

  if (activePanel === 'email') {
    return (
      <div className="space-y-6" data-testid="communications-page">
        <button onClick={() => setActivePanel(null)} className="text-sm text-[#1f3e80] hover:underline" data-testid="comms-back-btn">
          &larr; {lb.back}
        </button>
        <AcumbamailPanel lang={lang} onClose={() => setActivePanel(null)} />
      </div>
    );
  }

  if (activePanel === 'sms') {
    return (
      <div className="space-y-6" data-testid="communications-page">
        <button onClick={() => setActivePanel(null)} className="text-sm text-[#1f3e80] hover:underline" data-testid="comms-back-btn">
          &larr; {lb.back}
        </button>
        <EsendexPanel lang={lang} onClose={() => setActivePanel(null)} />
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="communications-page">
      <div className="flex items-center gap-3">
        <ChatCircleDots size={28} weight="duotone" className="text-[#1f3e80]" />
        <h1 className="text-3xl font-heading font-semibold tracking-tight text-stone-900">{lb.title}</h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl">
        <button onClick={() => setActivePanel('email')} data-testid="comms-email-card" className="text-left">
          <Card className="border-stone-200 hover:border-emerald-300 hover:shadow-md transition-all cursor-pointer h-full">
            <CardContent className="p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-lg bg-emerald-50 flex items-center justify-center">
                  <Envelope size={22} weight="duotone" className="text-emerald-600" />
                </div>
                <h2 className="text-base font-semibold text-stone-900">{lb.emailTitle}</h2>
              </div>
              <p className="text-xs text-stone-500 leading-relaxed">{lb.emailDesc}</p>
            </CardContent>
          </Card>
        </button>

        <button onClick={() => setActivePanel('sms')} data-testid="comms-sms-card" className="text-left">
          <Card className="border-stone-200 hover:border-amber-300 hover:shadow-md transition-all cursor-pointer h-full">
            <CardContent className="p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-lg bg-amber-50 flex items-center justify-center">
                  <DeviceMobile size={22} weight="duotone" className="text-amber-600" />
                </div>
                <h2 className="text-base font-semibold text-stone-900">{lb.smsTitle}</h2>
              </div>
              <p className="text-xs text-stone-500 leading-relaxed">{lb.smsDesc}</p>
            </CardContent>
          </Card>
        </button>
      </div>
    </div>
  );
}
